import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getRestaurantsLocations = createAsyncThunk(
  "Restaurant/getRestaurantsLocations",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/all_restaurants_in_map`,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurants = createAsyncThunk(
  "Restaurant/getRestaurants",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/restaurants`, {
          headers: getHeaders(),
          params: {
            admin_in_zones: 1,
            // is_pagination: data?.is_pagination === 1 ? 0 : 1,
            ...data,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurantsId = createAsyncThunk(
  "Restaurant/getRestaurantsId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/restaurants/${id}`,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addRestaurants = createAsyncThunk(
  "Restaurant/addRestaurants",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/restaurants`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateRestaurants = createAsyncThunk(
  "Restaurant/updateRestaurants",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/restaurants/${data.id}/update`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteRestaurants = createAsyncThunk(
  "Restaurant/deleteRestaurants",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/restaurants${
          !Array.isArray(id) ? `/${id}` : ""
        }`,
        {
          headers: getHeaders(),
          ...(Array.isArray(id) && { data: { ids: id } }), // إرسال `id` كمصفوفة داخل `data`
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "خطأ غير متوقع");
    }
  }
);

// SendPay
export const SendPay = createAsyncThunk(
  "Restaurant/SendPay",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/transactions`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getOrdersBillsTransactions = createAsyncThunk(
  "Restaurant/getOrdersBillsTransactions",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/transactions`, {
          headers: getHeaders(),
          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getSendAndReciveStatus = createAsyncThunk(
  "Restaurant/getSendAndReciveStatus",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/statuses`,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getSendAdnRecive = createAsyncThunk(
  "Restaurant/getSendAdnRecive",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders`,
          {},
          {
            headers: getHeaders(true),
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getSendAdnReciveRevenu = createAsyncThunk(
  "Restaurant/getSendAdnReciveRevenu",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/reports/revenue`,
          {
            headers: getHeaders(),
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getSendAdnReciveCreateOrder = createAsyncThunk(
  "Restaurant/getSendAdnReciveCreateOrder",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/create`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getSendAndReciveDetails = createAsyncThunk(
  "Restaurant/getSendAndReciveDetails",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/details/${id}`,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getLocationsTypes = createAsyncThunk(
  "Restaurant/getLocationsTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/location-types`,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getPlaceTypes = createAsyncThunk(
  "Restaurant/getPlaceTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-recive-orders/place-types`,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const RestaurantsSlice = createSlice({
  name: "Restaurant",
  initialState: {
    isRestaurantLoading: false,
    error: null,
    RestaurantArr: null,
    RestaurantIDArr: null,
    ordersBillsArray: null,
    SendAdnReciveArr: null,
    SendAndReciveStatusArr: null,
    SendAdnReciveRevenuArr: null,
    getSendAndReciveDetailsArr: null,
    PaginationRestaurantData: null,
    PlacesTypes: null,
    LocationsTypes: null,
    ResturantsLocationsData: null,
  },

  extraReducers: (builder) => {
    builder

      // getRestaurantsLocations
      .addCase(getRestaurantsLocations.pending, (state, action) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getRestaurantsLocations.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.ResturantsLocationsData = action.payload.data;
      })
      .addCase(getRestaurantsLocations.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      .addCase(getRestaurants.pending, (state, action) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        if (action.meta.arg?.is_pagination === 1) {
          state.PaginationRestaurantData = action.payload;
        } else if (!action.meta.arg?.type) {
          state.RestaurantArr = action.payload.data;
        }
      })
      .addCase(getRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getRestaurantsId
      .addCase(getRestaurantsId.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getRestaurantsId.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.RestaurantIDArr = action.payload.data;
      })
      .addCase(getRestaurantsId.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // addRestaurants
      .addCase(addRestaurants.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(addRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(addRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // updateRestaurants
      .addCase(updateRestaurants.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(updateRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // deleteRestaurants
      .addCase(deleteRestaurants.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(deleteRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        const idsToDelete = Array.isArray(action.meta.arg)
          ? action.meta.arg
          : [action.meta.arg];
        if (state.RestaurantArr) {
          state.RestaurantArr = state.RestaurantArr.filter(
            (ele) => !idsToDelete.includes(ele.id)
          );
        }
        if (state.PaginationRestaurantData) {
          state.PaginationRestaurantData.data = state?.PaginationRestaurantData?.data?.filter(
            (ele) => !idsToDelete.includes(ele.id)
          );
        }
      })
      .addCase(deleteRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // SendPay
      .addCase(SendPay.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(SendPay.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(SendPay.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getOrdersBillsTransactions
      .addCase(getOrdersBillsTransactions.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getOrdersBillsTransactions.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.ordersBillsArray = action.payload.data;
      })
      .addCase(getOrdersBillsTransactions.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      // getSendAdnRecive
      .addCase(getSendAdnRecive.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getSendAdnRecive.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.SendAdnReciveArr = action.payload.data;
      })
      .addCase(getSendAdnRecive.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getSendAndReciveStatus

      .addCase(getSendAndReciveStatus.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getSendAndReciveStatus.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.SendAndReciveStatusArr = action.payload.data?.statuses;
      })
      .addCase(getSendAndReciveStatus.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      // getSendAdnReciveRevenu

      .addCase(getSendAdnReciveRevenu.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getSendAdnReciveRevenu.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.SendAdnReciveRevenuArr = action.payload.data;
      })
      .addCase(getSendAdnReciveRevenu.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      // getSendAdnReciveCreateOrder
      .addCase(getSendAdnReciveCreateOrder.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getSendAdnReciveCreateOrder.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(getSendAdnReciveCreateOrder.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(getSendAndReciveDetails.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getSendAndReciveDetails.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.getSendAndReciveDetailsArr = action.payload.data?.data;
      })
      .addCase(getSendAndReciveDetails.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      .addCase(getPlaceTypes.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getPlaceTypes.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.PlacesTypes = action.payload.data;
      })
      .addCase(getPlaceTypes.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })

      .addCase(getLocationsTypes.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getLocationsTypes.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.LocationsTypes = action.payload.data;
      })
      .addCase(getLocationsTypes.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      });
  },
});

export default RestaurantsSlice.reducer;
